// @ts-expect-error: Missing type definitions for react-force-graph-2d
import type { NodeObject, LinkObject } from 'react-force-graph-2d'

// Categories
export const categories: NodeCategoriesType = {
  persona_natural: {
    es: 'Persona natural',
    color: '#27AE60',
    secondColor: '#BEE7CF',
    fontColor: '#000000',
  },
  actividad_economica: {
    es: 'Actividad económica',
    color: '#F2C94C',
    secondColor: '#FBEFC9',
    fontColor: '#000000',
  },
  persona_juridica: {
    es: 'Persona jurídica',
    color: '#FE7300',
    secondColor: '#FFD5B3',
    fontColor: '#000000',
  },
  causa: {
    es: 'Causa',
    color: '#2D9CDB',
    secondColor: '#C0E1F4',
    fontColor: '#000000',
  },
  persona_expuesta_politicamente: {
    es: 'P.E.P.',
    color: '#FF0000',
    secondColor: '#FFB3B3',
    fontColor: '#000000',
  },
  vehiculo: {
    es: 'Vehículo',
    color: '#8E44AD', // Purple
    secondColor: '#DCC6E0', // Light Purple
    fontColor: '#000000',
  },
}

export type CategoryType = keyof typeof categories
export type CategoryKeysType = keyof NodeCategoriesType

// Node
export type NodeType = {
  id: string
  entityType: string
  category: CategoryType
  feeds: string[]
  data: DataType
}

export type DataType = {
  [key: string]: Record<string, string>
}

export type NodeCategoriesType = {
  [key: string]: {
    es: string
    color: string
    secondColor: string
    fontColor: string
    [key: string]: string
  }
}

export type NodeObjectType = NodeObject &
  NodeType & {
    val: number
    color: string
    secondColor: string
    fontColor: string
    x?: number
    y?: number
  }

// Link
export type LinkType = {
  id: string
  entityType: string
  target: string
  source: string
  feeds: string[]
  data: DataType
}

export type NodeCoordinates = {
  x?: number
  y?: number
}

export type GraphNode = NodeObjectType & {
  x: number
  y: number
}

export type NodeWithCoordinates = {
  x: number
  y: number
  [key: string]: any
}

export type LinkObjectType = Partial<LinkObject> &
  Partial<LinkType> & {
    id: string
    source: string | number | NodeObjectType
    target: string | number | NodeObjectType
    label?: string
  }

export type ForceGraphInputType = {
  nodes: NodeObjectType[]
  links: Array<LinkObjectType>
}

export type NodeHoverCallback = (
  node: NodeObjectType | null,
  previousNode: NodeObjectType | null
) => void
